import React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import { useStores } from 'util/mobx/stores';
import SideMenuIconButton from 'components/SideMenuIconButton';

const WrapperFunctions = observer(() => {
  const { t } = useTranslation('material');
  const { t: searchTranslation } = useTranslation('materialSearch');
  const { materialStore, searchStore, guideStore } = useStores();

  const handlerReplaceGuidesMaterial = async () => {
    searchStore.openSearchPanel(m => {
      if (materialStore.materialDetail) {
        guideStore.replaceMaterialInGuide(m, { materialId: materialStore.materialDetail.materialId }).then(() => {
          if (materialStore.materialId) {
            materialStore.loadMaterialGuides(materialStore.materialId);
          }
        });
      }
    }, searchTranslation('searchItem.replace'));
  };

  const handlerDeleteGuidesMaterial = () => {
    if (materialStore.materialDetail) {
      materialStore.deleteGuidesMaterial({
        materialId: materialStore.materialDetail.materialId
      });
    }
  };

  return (
    <>
      <SideMenuIconButton
        handleClick={handlerReplaceGuidesMaterial}
        label={t('materialGlobalFunctions.button.replaceMaterial')}
        iconPath="icon_find_16.svg"
        disabled={!materialStore.materialGuides || materialStore.materialGuides.length === 0}
      />

      <SideMenuIconButton
        handleClick={handlerDeleteGuidesMaterial}
        red
        label={t('materialGlobalFunctions.button.deleteMaterial')}
        iconPath="icon_bin_16.svg"
        disabled={!materialStore.materialGuides || materialStore.materialGuides.length === 0}
      />
    </>
  );
});

export default WrapperFunctions;
